export default __webpack_public_path__ + "static/media/meteoBg.a58631ea.jpg";